// =============================================================================
// src/features/analytics/analytics-labels.ts - Labels compartilhados do Analytics.
// =============================================================================

import type { OmarAnalyticsKpi, OmarAnalyticsSentiment } from './analytics-data';

export const OMAR_ANALYTICS_SENTIMENT_LABELS: Record<OmarAnalyticsSentiment, string> = {
  positive: 'Positivo',
  neutral: 'Neutro',
  negative: 'Critico',
};

/** 036 (2026-09-23): o sentimento vivo é IMPACTO para o Omar, no vocabulário
 * da campanha. OMAR_ANALYTICS_SENTIMENT_LABELS segue para as superfícies mock. */
export const OMAR_ANALYTICS_IMPACT_LABELS: Record<OmarAnalyticsSentiment, string> = {
  positive: 'Promotor',
  neutral: 'Neutro',
  negative: 'Detrator',
};

/** Abaixo disto a tag fica esmaecida (decisão do usuário: mostrar, não esconder). */
export const ANALYTICS_IMPACT_LOW_CONFIDENCE = 0.6;

export const OMAR_ANALYTICS_TREND_ICONS: Record<OmarAnalyticsKpi['trend'], string> = {
  up: 'ti-trending-up',
  down: 'ti-trending-down',
  flat: 'ti-minus',
};
